var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9992 3C11.0228 3 7.79922 6.22355 7.79922 10.2V19.1761L6.64582 20.2246C5.50395 21.2627 4.93301 21.7817 4.88251 22.2314C4.83874 22.6211 4.98817 23.0076 5.28273 23.2666C5.62255 23.5653 6.39416 23.5653 7.93737 23.5653H11.7796C11.7797 25.3436 13.2213 26.7852 14.9996 26.7852C16.7779 26.7852 18.2196 25.3436 18.2196 23.5653H22.0616C23.6048 23.5653 24.3764 23.5653 24.7162 23.2666C25.0107 23.0076 25.1602 22.6211 25.1164 22.2314C25.0659 21.7817 24.495 21.2627 23.3531 20.2246L22.1992 19.1756V10.2C22.1992 6.22355 18.9757 3 14.9992 3ZM9.43922 19.9016V10.2C9.43922 7.1293 11.9285 4.64 14.9992 4.64C18.0699 4.64 20.5592 7.1293 20.5592 10.2V19.9011L22.2499 21.4381C22.4528 21.6225 22.6287 21.7827 22.7817 21.9237C22.5737 21.9251 22.3357 21.9253 22.0616 21.9253H7.93737C7.66321 21.9253 7.42525 21.9251 7.21721 21.9237C7.3702 21.7827 7.54615 21.6225 7.74901 21.4381L9.43922 19.9016ZM16.5796 23.5653H13.4196C13.4197 24.4379 14.127 25.1452 14.9996 25.1452C15.8722 25.1452 16.5796 24.4379 16.5796 23.5653Z",
    fill: "#7D8C97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsIconGray);
export default __webpack_public_path__ + "static/media/alerts_icon_gray.52d1b3663c556e0de8901046c0b1c500.svg";
export { ForwardRef as ReactComponent };